'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelSchedulerCallback = exports.requestSchedulerCallback = exports.cancelIdleCallback = exports.requestIdleCallback = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable compat/compat */
var requestIdleCallback = exports.requestIdleCallback = window.requestIdleCallback || setTimeout;
var cancelIdleCallback = exports.cancelIdleCallback = window.cancelIdleCallback || clearTimeout;

var Scheduler = _react2.default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && _react2.default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Scheduler;

// TODO fix when scheduler api stable
var requestSchedulerCallback = exports.requestSchedulerCallback = Scheduler ? function (callback) {
  // forward compat: we need to check arity because argument order changed in 16.9.0
  return Scheduler.unstable_scheduleCallback.length === 2 ? Scheduler.unstable_scheduleCallback(callback) : Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, callback);
} : requestIdleCallback;

var cancelSchedulerCallback = exports.cancelSchedulerCallback = Scheduler ? function (id) {
  if (id) {
    Scheduler.unstable_cancelCallback(id);
  }
} : cancelIdleCallback;